import React, { Fragment, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import CheckoutStep from "../CheckoutStep";
import { useHistory } from "react-router-dom";
import axios from "axios";
import swal from "sweetalert";
import MetaTag from "../../../layout/MetaTag";
import "../checout.css";

// Icons
import PinDropIcon from "@mui/icons-material/PinDrop";
import InsertEmoticonIcon from "@mui/icons-material/InsertEmoticon";
import EmailIcon from "@mui/icons-material/Email";
import HomeIcon from "@mui/icons-material/Home";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import PhoneIcon from "@mui/icons-material/Phone";
import MyLocationIcon from "@mui/icons-material/MyLocation";
import TransferWithinAStationIcon from "@mui/icons-material/TransferWithinAStation";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import SecurityIcon from "@mui/icons-material/Security";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import Loader from "../../../layout/loader";
import { savingCartInfoAction } from "../../../redux/actions/cartAction";
import {
  createSaveInfo,
  clearErrorAction,
  gettingSaveInfo,
} from "../../../redux/actions/saveAddressAction";
import { SAVE_ADDRESS_RESET } from "../../../redux/constants/SaveAddressConstants";

function CheckoutForDirectBuy() {
  const history = useHistory();
  const dispatch = useDispatch();

  // User details
  const { user } = useSelector((state) => state.user || {});

  // Direct buy product from localStorage
  const productBuy = JSON.parse(localStorage.getItem("productBuy") || "null");

  // Save shipping info selector
  const { loading, success, message, error } = useSelector(
    (state) => state.saveInfo || {}
  );

  const {
    loading: infoLoading,
    info = [],
    error: infoError,
  } = useSelector((state) => state.info || {});

  const [name, setName] = useState(user?.firstName || user?.name || "");
  const [email, setEmail] = useState(user?.email || "");
  const [address, setAddress] = useState("");
  const [landMark, setLandMark] = useState("");
  const [city, setCity] = useState("");
  const [autoSaveShippingState, setAutoSaveShippingState] = useState("");
  const [district, setDistrict] = useState("");
  const [pincode, setPincode] = useState("");
  const [phoneNo, setPhoneNo] = useState(user?.number || "");
  const [pincodeVerify, setPincodeVerfiy] = useState("");
  const [pincodeLoading, setPincodeLoading] = useState(false);

  // Address selection
  const [addressChecked, setAddressChecked] = useState("");

  const directSubTotal =
    (Number(productBuy?.quantity) || 1) * (Number(productBuy?.price) || 0);

  useEffect(() => {
    dispatch(gettingSaveInfo());
  }, [dispatch]);

  // Auto-select first saved address if available
  useEffect(() => {
    if (info && info.length > 0 && !addressChecked) {
      setAddressChecked(info[0]._id);
    }
  }, [info, addressChecked]);

  useEffect(() => {
    if (error) {
      swal({
        title: "Error",
        text: error,
        icon: "error",
      });
      dispatch(clearErrorAction());
    }
    if (success === true) {
      swal({
        title: "Address Saved!",
        text: "Your delivery address has been saved successfully.",
        icon: "success",
      });
      dispatch({ type: SAVE_ADDRESS_RESET });
      dispatch(gettingSaveInfo());
    }

    if (infoError) {
      swal({
        title: "Error",
        text: infoError,
        icon: "error",
      });
      dispatch(clearErrorAction());
    }
  }, [dispatch, error, success, message, infoError]);

  const onSubmitHandler = (e) => {
    e.preventDefault();
    if (!/^\d{10}$/.test(String(phoneNo || "").trim())) {
      return swal({
        title: "Validation Error",
        text: "Please enter a valid 10-digit mobile number!",
        icon: "info",
        button: "OK",
      });
    }
    dispatch(
      createSaveInfo({
        name,
        email,
        address,
        landMark,
        city,
        autoSaveShippingState,
        pincode: pincode || pincodeVerify,
        phoneNo,
        district,
      })
    );
  };

  const CityPincodeHandler = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    const cleanPin = String(pincodeVerify || "").trim();
    if (!cleanPin || cleanPin.length !== 6) {
      return swal({
        title: "Validation Error",
        text: "Please type a valid 6-digit Pincode!",
        icon: "info",
      });
    }

    setPincode(cleanPin);
    setPincodeLoading(true);

    try {
      // 1. Backend proxy
      const { data } = await axios.get(`/api/pincode/${cleanPin}`);
      if (data && data.success) {
        setCity(data.city || "");
        setAutoSaveShippingState(data.state || "");
        setDistrict(data.district || data.city || "");
        return;
      }
      throw new Error(data?.message || "Not found");
    } catch (err) {
      // 2. Direct browser fetch without Authorization header
      try {
        const directResp = await fetch(`https://api.postalpincode.in/pincode/${cleanPin}`);
        const directData = await directResp.json();
        if (
          Array.isArray(directData) &&
          directData[0]?.Status === "Success" &&
          directData[0]?.PostOffice?.length > 0
        ) {
          const po = directData[0].PostOffice[0];
          setCity(po.Name || po.District || "");
          setAutoSaveShippingState(po.State || "");
          setDistrict(po.District || po.Name || "");
          return;
        }
      } catch (directErr) {
        // 3. Fast third-party fallback
        try {
          const zipResp = await fetch(`https://api.zippopotam.us/in/${cleanPin}`);
          const zipData = await zipResp.json();
          if (zipData && zipData.places && zipData.places.length > 0) {
            setCity(zipData.places[0]["place name"] || "");
            setAutoSaveShippingState(zipData.places[0]["state"] || "");
            setDistrict(zipData.places[0]["place name"] || "");
            return;
          }
        } catch (zipErr) {}
      }

      swal({
        title: "Pincode Notice",
        text: "Could not auto-fetch city. Please enter your City and State manually.",
        icon: "info",
      });
    } finally {
      setPincodeLoading(false);
    }
  };

  const addressCheckoutHandler = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    try {
      if (!addressChecked) {
        return swal({
          title: "Select Address",
          text: "Please select a delivery address to continue!",
          icon: "info",
        });
      }

      const { data } = await axios.get(`/api/shipping/info/${addressChecked}`);

      if (data && data.msg && data.msg.length > 0) {
        const item = data.msg[0];
        const shippingData = {
          name: item.name,
          email: item.email,
          address: item.address,
          landMark: item.landMark,
          city: item.city,
          state: item.state,
          pincode: item.pincode,
          phoneNo: item.phoneNo,
          district: item.district,
        };

        dispatch(savingCartInfoAction(shippingData));

        setTimeout(() => {
          history.push("/confirm/orders/directbuy");
        }, 300);
      } else {
        return swal({
          title: "Error",
          text: "Could not load selected shipping details. Please try again.",
          icon: "error",
        });
      }
    } catch (err) {
      return swal({
        title: "Error",
        text: "Unable to proceed with selected address.",
        icon: "error",
      });
    }
  };

  return (
    <Fragment>
      <MetaTag title={"Checkout - Direct Buy | IM Online Shopping"} />

      <div className="checkout-page-root">
        {/* Stepper Header */}
        <CheckoutStep activeStep={0} />

        {loading ? (
          <Loader />
        ) : (
          <div className="checkout-main-wrapper">
            <div className="checkout-grid-layout">
              {/* ── LEFT COLUMN: Shipping & Address Selection ── */}
              <div className="checkout-left-column">
                {/* 1. Saved Addresses Card (if any exist) */}
                {info && info.length > 0 && (
                  <div className="checkout-section-card">
                    <div className="section-header-row">
                      <div className="section-title-wrap">
                        <span className="step-num-pill">1</span>
                        <div>
                          <h2 className="section-title">Delivery Address</h2>
                          <p className="section-subtitle">
                            Select a saved delivery address or enter a new one below
                          </p>
                        </div>
                      </div>
                    </div>

                    {infoLoading ? (
                      <div style={{ textAlign: "center", padding: "20px 0" }}>
                        <p style={{ color: "#64748b", fontWeight: 700 }}>
                          Loading your saved addresses...
                        </p>
                      </div>
                    ) : (
                      <div className="saved-addresses-grid">
                        {info.map((add, index) => {
                          const isSelected = addressChecked === add._id;
                          return (
                            <div
                              key={add._id}
                              className={`address-card ${isSelected ? "selected-card" : ""}`}
                              onClick={() => {
                                setAddressChecked(add._id);
                              }}
                            >
                              <div>
                                <div className="address-card-header">
                                  <label className="radio-label">
                                    <input
                                      type="radio"
                                      name="selectedAddressDirect"
                                      value={add._id}
                                      checked={isSelected}
                                      onChange={() => {
                                        setAddressChecked(add._id);
                                      }}
                                    />
                                    <span className="address-recipient-name">
                                      {add.name}
                                    </span>
                                  </label>
                                  <span className="address-type-badge">
                                    {index === 0 ? "Default" : `Address #${index + 1}`}
                                  </span>
                                </div>

                                <div className="address-card-body">
                                  <p className="address-text">
                                    {add.address}
                                    {add.landMark ? `, Near ${add.landMark}` : ""}
                                  </p>
                                  <p className="address-city-line">
                                    {add.city}, {add.state} - <strong>{add.pincode}</strong>
                                  </p>
                                  {add.district && add.district !== add.city && (
                                    <p style={{ fontSize: "12px", color: "#64748b", margin: "2px 0 0" }}>
                                      District: {add.district}
                                    </p>
                                  )}
                                  <p className="address-phone-line">
                                    <PhoneIcon style={{ fontSize: "14px" }} />
                                    +91 {add.phoneNo}
                                  </p>
                                </div>
                              </div>

                              {isSelected && (
                                <div className="card-selected-indicator">
                                  <CheckCircleIcon />
                                  <span>Selected for Delivery</span>
                                </div>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    )}

                    {addressChecked && (
                      <div className="deliver-here-action-row">
                        <button
                          type="button"
                          className="continue-checkout-btn"
                          onClick={addressCheckoutHandler}
                        >
                          Deliver to this Address & Continue →
                        </button>
                      </div>
                    )}
                  </div>
                )}

                {/* 2. Add New Address Card */}
                <div className="checkout-section-card">
                  <div className="section-header-row">
                    <div className="section-title-wrap">
                      <span className="step-num-pill">
                        {info && info.length > 0 ? "+" : "1"}
                      </span>
                      <div>
                        <h2 className="section-title">
                          {info && info.length > 0
                            ? "Add a New Delivery Address"
                            : "Enter Delivery Address"}
                        </h2>
                        <p className="section-subtitle">
                          Enter your exact address for prompt doorstep shipping
                        </p>
                      </div>
                    </div>
                  </div>

                  <form className="modern-checkout-form" onSubmit={onSubmitHandler}>
                    <div className="form-grid-2">
                      <div className="form-field-group">
                        <label className="form-field-label">Full Name *</label>
                        <div className="modern-input-field">
                          <InsertEmoticonIcon />
                          <input
                            type="text"
                            required
                            placeholder="Recipient full name"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                          />
                        </div>
                      </div>

                      <div className="form-field-group">
                        <label className="form-field-label">Email Address *</label>
                        <div className="modern-input-field">
                          <EmailIcon />
                          <input
                            type="email"
                            required
                            placeholder="Order updates email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="form-grid-2">
                      <div className="form-field-group">
                        <label className="form-field-label">House / Flat / Street *</label>
                        <div className="modern-input-field">
                          <HomeIcon />
                          <input
                            type="text"
                            required
                            placeholder="House No., Building, Street Name"
                            value={address}
                            onChange={(e) => setAddress(e.target.value)}
                          />
                        </div>
                      </div>

                      <div className="form-field-group">
                        <label className="form-field-label">Landmark *</label>
                        <div className="modern-input-field">
                          <LocationCityIcon />
                          <input
                            type="text"
                            required
                            placeholder="Nearby landmark (e.g. Near Hospital)"
                            value={landMark}
                            onChange={(e) => setLandMark(e.target.value)}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="form-grid-2">
                      <div className="form-field-group">
                        <label className="form-field-label">Postal Pincode *</label>
                        <div className="modern-input-field">
                          <PinDropIcon />
                          <div className="pincode-input-wrap">
                            <input
                              type="number"
                              required
                              placeholder="6-digit Pincode"
                              value={pincodeVerify}
                              onChange={(e) => setPincodeVerfiy(e.target.value)}
                            />
                            <button
                              type="button"
                              onClick={CityPincodeHandler}
                              className="pincode-search-btn"
                              disabled={pincodeLoading}
                            >
                              {pincodeLoading ? "Checking..." : "Search here"}
                            </button>
                          </div>
                        </div>

                        {autoSaveShippingState && (
                          <div className="autofill-notice-chip">
                            <CheckCircleIcon />
                            <span>
                              Auto-filled: {city ? `${city}, ` : ""}{district ? `${district}, ` : ""}{autoSaveShippingState}
                            </span>
                          </div>
                        )}
                      </div>

                      <div className="form-field-group">
                        <label className="form-field-label">Mobile Number *</label>
                        <div className="modern-input-field">
                          <PhoneIcon />
                          <input
                            type="tel"
                            required
                            placeholder="10-digit Mobile Number"
                            value={phoneNo}
                            onChange={(e) => setPhoneNo(e.target.value)}
                            maxLength={10}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="form-grid-3">
                      <div className="form-field-group">
                        <label className="form-field-label">State</label>
                        <div className="modern-input-field readonly-field">
                          <TransferWithinAStationIcon />
                          <input
                            type="text"
                            required
                            placeholder="Auto-filled State"
                            value={autoSaveShippingState}
                            readOnly={true}
                          />
                        </div>
                      </div>

                      <div className="form-field-group">
                        <label className="form-field-label">District</label>
                        <div className="modern-input-field readonly-field">
                          <MyLocationIcon />
                          <input
                            type="text"
                            required
                            placeholder="Auto-filled District"
                            value={district}
                            readOnly={true}
                          />
                        </div>
                      </div>

                      <div className="form-field-group">
                        <label className="form-field-label">City</label>
                        <div className="modern-input-field readonly-field">
                          <HomeWorkIcon />
                          <input
                            type="text"
                            required
                            placeholder="Auto-filled City"
                            value={city}
                            readOnly={true}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="form-action-row">
                      <button
                        type="submit"
                        className="save-shipping-submit-btn"
                        disabled={!autoSaveShippingState}
                      >
                        Save & Use This Address
                      </button>
                    </div>
                  </form>
                </div>
              </div>

              {/* ── RIGHT COLUMN: Order Summary & Trust Guarantee ── */}
              <div className="checkout-right-column">
                <div className="order-summary-card">
                  <div className="summary-header">
                    <h3>Order Summary</h3>
                    <span className="items-count-badge">Direct Purchase</span>
                  </div>

                  {/* Item Preview */}
                  {productBuy && (
                    <div className="summary-items-list">
                      <div className="summary-item-row">
                        <img
                          src={productBuy.image || "/favicon.ico"}
                          alt={productBuy.name}
                          className="summary-item-thumb"
                        />
                        <div className="summary-item-info">
                          <p className="summary-item-name" title={productBuy.name}>
                            {productBuy.name}
                          </p>
                          <p className="summary-item-meta">
                            Qty: <strong>{productBuy.quantity || 1}</strong> × ₹{Number(productBuy.price).toLocaleString("en-IN")}
                          </p>
                        </div>
                        <span className="summary-item-total">
                          ₹{directSubTotal.toLocaleString("en-IN")}
                        </span>
                      </div>
                    </div>
                  )}

                  {/* Price Breakdown */}
                  <div className="summary-totals-box">
                    <div className="summary-row">
                      <span>Item Price</span>
                      <span>₹{directSubTotal.toLocaleString("en-IN")}</span>
                    </div>
                    <div className="summary-row">
                      <span>Delivery Charges</span>
                      <span className="free-delivery-badge">FREE</span>
                    </div>
                    <div className="summary-row total-row">
                      <span>Total Amount</span>
                      <span className="total-amount">₹{directSubTotal.toLocaleString("en-IN")}</span>
                    </div>
                  </div>

                  {/* Trust & Guarantee Badges */}
                  <div className="trust-badges-container">
                    <div className="trust-badge-item">
                      <SecurityIcon />
                      <div>
                        <strong>100% Secure Checkout</strong>
                        <span>256-bit SSL encrypted checkout</span>
                      </div>
                    </div>
                    <div className="trust-badge-item">
                      <LocalShippingIcon />
                      <div>
                        <strong>Free Doorstep Delivery</strong>
                        <span>Fast local merchant dispatch</span>
                      </div>
                    </div>
                    <div className="trust-badge-item">
                      <VerifiedUserIcon />
                      <div>
                        <strong>Buyer Protection</strong>
                        <span>Easy returns & verified quality</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </Fragment>
  );
}

export default CheckoutForDirectBuy;
